export default __webpack_public_path__ + "static/media/shield.40423294.png";